import { NavigationService } from '../../../services/navigation-service';
import { AgendaService } from '../../../services/agenda-service';
import { Router } from '@angular/router';
import {
  OnInit,
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef
} from '@angular/core';

import { Subject } from 'rxjs/Subject';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarDateFormatter
} from 'angular-calendar';
import { CustomDateFormatter } from '../../../utils';
import { PATH_BUSCADOR, PATH_BUSCADOR_CONSIGNAS, PATH_CONSIGNA_DETAIL } from '../../../navigation/navigation.module';
import { RateComponent } from '../../common/dialog/rate/rate.component';
import { TextDialogComponent } from '../../common/dialog/text-dialog/text-dialog.component';
import {MdDialog, MdDialogRef} from '@angular/material';
import { DialogsService } from '../../../services/dialogs-service';
import { dateToUnixTime, parseDate, getFirstDayOfWeek, getLastDayOfWeek } from '../../../utils/DateHelper';
import * as moment from 'moment';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }
  ]
})
export class AgendaComponent implements OnInit {

  private newConsignaResponse: any = {};

  refresh: Subject<any> = new Subject();
  events: any[];

  locale: string = 'es';
  selectedDate = new Date();
  selectedDateEvents = [];
  view : moment.unitOfTime.DurationConstructor = 'month';
  viewDate = new Date();
  weekEvents = [];
  anyTimeEvents = [];

  detailEventsList = 'today';

  currentUserId = Number(localStorage.getItem('userId'));

  navigationTimeout;


  // Variables para consignas continuas. "events" es por eventos del calendario, que también se conoce como consignas en jerga de Unco
  private dayEventsInfo: any = {};
  private eventsSlotsAssignments: any = {};
  private dayEventSlots: any = {};
  MAX_VISIBLE_SLOTS = 3;

  // Variables para funcionalidad drag & drop de consignas en las diferentes vistas
  dragClass: string = '';
  dragDay: any;
  dragCurrentDay: any;
  agendaOffsetLeft: number;
  agendaSingleHeaderWidth: number;
  currentTargetDay: any;
  ghost: any;
  @ViewChild('agenda') agendaDOM:any;

  constructor(private navigationService: NavigationService,
              private agendaService: AgendaService,
              public dialog: MdDialog,
              private dialogsService: DialogsService,
              private router: Router) {


  }

  ngOnInit() {
    this.loadDefaultEvents();
    this.retrieveWeekEvents(this.selectedDate);
    this.retrieveAnyTimeEvents();
  }

  previousClicked(){
    clearTimeout(this.navigationTimeout);

    let start: Date, end: Date;
    if (this.view !== 'week') {
      start = moment(this.viewDate).subtract(1, this.view).startOf(this.view).toDate();
      end = moment(this.viewDate).subtract(1, this.view).endOf(this.view).toDate();
    } else {
      start = getFirstDayOfWeek(moment(this.viewDate).subtract(1, this.view).toDate()).toDate();
      end = getLastDayOfWeek(moment(this.viewDate).subtract(1, this.view).toDate()).toDate();
    }

    this.selectedDate = moment(this.selectedDate).subtract(1, this.view).toDate();

    this.navigationTimeout = setTimeout(_=> {
      this.loadEvents(start, end);
      this.retrieveWeekEvents(this.selectedDate);
    }, 1000);
  }

  previousYearClicked(){
    clearTimeout(this.navigationTimeout);

    // Notar que en el caso de ir a la semana o mes anterior o siguiente, el viewDate es actualizado automáticamente
    // por las directivas mwlCalendarPreviousView y mwlCalendarNextView respectivamente
    this.viewDate = moment(this.viewDate).subtract(1, 'year').toDate();

    let start: Date, end: Date;
    if (this.view !== 'week') {
      start = moment(this.viewDate).startOf(this.view).toDate();
      end = moment(this.viewDate).endOf(this.view).toDate();
    } else {
      start = getFirstDayOfWeek(this.viewDate).toDate();
      end = getLastDayOfWeek(this.viewDate).toDate();
    }

    this.selectedDate = moment(this.selectedDate).subtract(1, 'year').toDate();

    this.navigationTimeout = setTimeout(_=> {
      this.loadEvents(start, end);
      this.retrieveWeekEvents(this.selectedDate);
    }, 1000);
  }

  nextClicked(){
    clearTimeout(this.navigationTimeout);

    let start: Date, end: Date;
    if (this.view !== 'week') {
      start = moment(this.viewDate).add(1, this.view).startOf(this.view).toDate();
      end = moment(this.viewDate).add(1, this.view).endOf(this.view).toDate();
    } else {
      start = getFirstDayOfWeek(moment(this.viewDate).add(1, this.view).toDate()).toDate();
      end = getLastDayOfWeek(moment(this.viewDate).add(1, this.view).toDate()).toDate();
    }

    this.selectedDate = moment(this.selectedDate).add(1, this.view).toDate();

    this.navigationTimeout = setTimeout(_=> {
      this.loadEvents(start, end);
      this.retrieveWeekEvents(this.selectedDate);
    }, 1000);
  }

  nextYearClicked(){
    clearTimeout(this.navigationTimeout);

    // Notar que en el caso de ir a la semana o mes anterior o siguiente, el viewDate es actualizado automáticamente
    // por las directivas mwlCalendarPreviousView y mwlCalendarNextView respectivamente
    this.viewDate = moment(this.viewDate).add(1, 'year').toDate();

    let start: Date, end: Date;
    if (this.view !== 'week') {
      start = moment(this.viewDate).startOf(this.view).toDate();
      end = moment(this.viewDate).endOf(this.view).toDate();
    } else {
      start = getFirstDayOfWeek(this.viewDate).toDate();
      end = getLastDayOfWeek(this.viewDate).toDate();
    }

    this.selectedDate = moment(this.selectedDate).add(1, 'year').toDate();

    this.navigationTimeout = setTimeout(_=> {
      this.loadEvents(start, end);
      this.retrieveWeekEvents(this.selectedDate);
    }, 1000);
  }

  loadDefaultEvents(){
    let start = moment(this.viewDate).startOf('month').toDate();
    let end = moment(this.viewDate).endOf('month').toDate();
    this.loadEvents(start, end);
  }

  toggleNav(){
    this.navigationService.toggleNav(true);
  }

  changeView(view){
    this.view = view;
    this.viewDate = this.selectedDate;

    let start: Date, end: Date;
    if (this.view !== 'week') {
      start = moment(this.viewDate).startOf(this.view).toDate();
      end = moment(this.viewDate).endOf(this.view).toDate();
    } else {
      start = getFirstDayOfWeek(this.viewDate).toDate();
      end = getLastDayOfWeek(this.viewDate).toDate();
    }
    this.loadEvents(start, end);
  }

  loadEvents(fromDate: Date, toDate: Date){
    // Llamada para todo el mes
    this.agendaService.getConsignas(fromDate, toDate, true, false)
      .subscribe( data => {

        // resetear estructuras de datos de la agenda al cargar un nuevo mes
        this.selectedDateEvents = [];
        this.dayEventsInfo = {};
        this.eventsSlotsAssignments = {};
        this.dayEventSlots = {};

        this.events = data.ResponseData.map(item => {

          let endDate = parseDate(item.EndDate);
          let startDate = parseDate(item.StartDate);

          let calendarEvent = {
            EstadoConsigna: item.EstadoConsigna,
            end: endDate,
            start: startDate,
            title: item.Title,
            id: item.Id,
            color: {
              primary: '#4b81b0',
              secondary: '#4b81b0'
            },
            showOwnerButtons: this.currentUserId === item.UsuarioCreadorId,
            colaboradores: item.ConsignaResponsables ? item.ConsignaResponsables.reduce((acc, c) => acc+', '+c.UserFullName, '').substr(2) : '',
            descripcion: item.Descripcion,
            cliente: item.Cliente ? item.Cliente.FullName : ''
          };

          if (moment(startDate).isSameOrBefore(moment(this.selectedDate).endOf('day')) &&
                moment(endDate).isSameOrAfter(moment(this.selectedDate).startOf('day'))) {
              this.selectedDateEvents.push(calendarEvent);
          }

          this.loadEventInfoToDictionary(item);

          return calendarEvent;
        });

        this.fillEventsSlots();
      });
  }

  /**
  * Una vez que eventsSlotsAssignments está completo, podemos consultar desde el template con un día y un id de evento, el slot que dicho evento debe
  * ocupar en ese día.
  */
  getEventSlot(day, event) {
    if (!this.eventsSlotsAssignments[event]) return this.MAX_VISIBLE_SLOTS;

    const dayId = Number(moment(day.date).startOf('day').format('X'));

    return typeof this.eventsSlotsAssignments[event][dayId] !== 'undefined' ?
            this.eventsSlotsAssignments[event][dayId].slot :
            this.MAX_VISIBLE_SLOTS;
  }

  /**
  * Una vez que eventsSlotsAssignments está completo, podemos consultar desde el template con un día y un id de evento, si debemos mostrar
  * el título del evento en esa celda o no.
  */
  shouldDisplayEventTitle(day, event) {
    if (!this.eventsSlotsAssignments[event]) return false;

    // mostrarlo si el day es domingo, o si el evento no estuvo ayer o si estuvo pero en un slot distinto (este último caso no se da
    // nunca pero lo dejamos al check, no hace daño)
    const yesterday = Number(moment(day.date).startOf('day').format('X')) - 24 * 60 * 60;
    const today = Number(moment(day.date).startOf('day').format('X'));

    return moment(day.date).day() === 0 ||
            !this.eventsSlotsAssignments[event][yesterday] ||
            this.eventsSlotsAssignments[event][yesterday].slot !== this.eventsSlotsAssignments[event][today].slot;
  }

  /**
  * Dado un día y un id de evento, devolver el ancho de su div contenedor. Éste está dado por el resto de días que le quedan al evento, o el resto de
  * días en la semana. Lo que sea menor.
  * Éste se aplica si es que 'day' no es el último día de la semana y si es que el evento no termina en el día 'day'.
  */
  getEventWidth(day, event) {
    if (!this.eventsSlotsAssignments[event]) return '0%';

    const current = Number(moment(day.date).startOf('day').format('X'));
    const extraWidth = Math.min(this.eventsSlotsAssignments[event][current].remaining, 6 - moment(day.date).day());

    return 'calc(' + (100 + extraWidth * 100) + '% + ' + extraWidth + 'px)';
  }

  /**
  * Expandir el alto de la celda si el slot 2 está asignado, o si hay 2 slots visibles asignados y hay 3 eventos o más
  */
  shouldUseFullCell(day) {
    const dayId = Number(moment(day.date).startOf('day').format('X'));
    const tmp = day.events.filter(e =>
      this.eventsSlotsAssignments[e.id] &&
      this.eventsSlotsAssignments[e.id][dayId] &&
      this.eventsSlotsAssignments[e.id][dayId].slot === 2
    );
    if (tmp.length > 0) {
      return true;
    } else {
      const tmp2 = day.events.filter(e =>
        this.eventsSlotsAssignments[e.id] &&
        this.eventsSlotsAssignments[e.id][dayId] &&
        this.eventsSlotsAssignments[e.id][dayId].slot < this.MAX_VISIBLE_SLOTS
      );
      return tmp2.length >= 2 && day.events.length >= 3;
    }
  }

  /**
  * Número de eventos extra en esta celda. Los que aparecen al lado del signo +
  */
  displayPlusEvents(day) {
    const dayId = Number(moment(day.date).startOf('day').format('X'));
    const tmp = day.events.filter(e =>
      this.eventsSlotsAssignments[e.id] &&
      this.eventsSlotsAssignments[e.id][dayId] &&
      this.eventsSlotsAssignments[e.id][dayId].slot >= this.MAX_VISIBLE_SLOTS
    );
    return tmp.length;
  }

  /**
  * Si es un evento que abarca varios días se utiliza un color de fondo distinto
  */
  isMultiDayEvent(event) {
    const current = Number(moment(event.start).startOf('day').format('X'));
    const end = Number(moment(event.end).endOf('day').format('X'));
    const totalDays = Math.round((end - current) / (24*60*60));
    return totalDays > 1;
  }

  /**
  * En esta función cargamos el evento 'item' a un diccionario 'dayEventsInfo' que mapea
  * day-timestamp => array de eventos que ocurren en ese día (y cada evento trae su duración en días en la property totalDays)
  * Precondición: los eventos en data.ResponseData provenientes de agendaService.getConsignas, que son los que se agregan aquí, vienen ordenados cronológicamente.
  */
  loadEventInfoToDictionary(item) {
    let current = Number(moment(item.StartDate*1000).startOf('day').format('X'));
    const end = Number(moment(item.EndDate*1000).endOf('day').format('X'));
    const totalDays = Math.round((end - current) / (24*60*60));

    do {
      this.dayEventsInfo[current] = this.dayEventsInfo[current] || [];
      this.dayEventsInfo[current].push({id: item.Id, totalDays: totalDays});
      current += 24 * 60 * 60;
    } while (current <= end);
  }

  /**
  * Por cada día 'd' de la agenda actual visible, tomar los eventos que ocurren en 'd' y asignarles slots de la celda en cuestión en el diccionario
  * dayEventSlots que mapea (day-timestamp, numero de slot) => id de evento que lo ocupa.
  * Hay slots infinitos disponibles pero sólo MAX_VISIBLE_SLOTS se ven en las celdas de la agenda. El primer orden de prioridad es eventos que comenzaron antes,
  * el segundo orden de prioridad es por mayor duración del evento. Es decir ordenados cronológicamente y por duración descendente.
  */
  fillEventsSlots() {
    Object.keys(this.dayEventsInfo).forEach(dayId => {
      // ordenar los eventos candidatos para los slots de este día en base a su duración
      this.dayEventsInfo[dayId].sort((a, b) => b.totalDays - a.totalDays);

      this.dayEventsInfo[dayId].forEach(e => {
        // si este evento ya fue asignado a algun slot no lo procesemos: la asignación de un evento a slots es FINAL
        if (!this.eventsSlotsAssignments[e.id]) {
          // Cada elemento de eventsSlotsAssignments es un diccionario que dice (evento, dia)=>{slot, días pendientes del evento}, es decir que podría extenderse fácilmente a casos
          // donde el evento no siempre va a estar en el mismo slot. Pero eso NO sucede en nuestro algoritmo.
          // Si fue asignado a algún slot entonces queda en ese mismo slot por el resto de su duración.
          this.eventsSlotsAssignments[e.id] = {};

          // buscar primer slot libre en el primer día del evento
          let slot = 0;
          while (this.dayEventSlots[dayId] && this.dayEventSlots[dayId][slot]) {
            ++slot;
          }

          let current = Number(dayId);
          const end = current + (e.totalDays-1) * 24 * 60 * 60;
          do {
            this.dayEventSlots[current] = this.dayEventSlots[current] || [];
            this.dayEventSlots[current][slot] = e.id;

            this.eventsSlotsAssignments[e.id][current] = {slot, remaining: (end - current) / (24 * 60 * 60)};

            current += 24 * 60 * 60;
          } while (current <= end);
        }
      });
    });
  }

  handleDragStart(e, evento) {
    // Con esto fixeamos la ghost image para firefox. También podría ocultarse el div de la consigna poniendo e.target.style.opacity = '0'
    // debajo de esto, para dar el efecto de que estamos realmente moviendo de lugar la consigna y no un ghost image.
    if (this.view === 'month') {
      this.ghost = e.target.cloneNode(true);
      this.ghost.style.position = 'absolute';
      this.ghost.style.top = '-150px';
      this.ghost.style.width = e.target.children[0].offsetWidth + 'px';
      document.body.appendChild(this.ghost);
      e.dataTransfer.setDragImage(this.ghost, 0, 0);
    }

    // bajar la opacidad de la consigna (evento) que está siendo arrastrada
    // e.target.style.opacity = '0';

    // configurar el payload para que contenga el id del evento
    e.dataTransfer.setData('text/plain', evento.id);

    this.dragClass = 'dragging';
    this.dragDay = moment(evento.start).startOf('day');
    this.dragCurrentDay = moment().startOf('day');

    // Obtener valores útiles para el cálculo del día en dragover en la vista
    // semana (ya que no es fácil obtener el valor de "day" para esta vista)
    if (this.view === 'week') {
      const elem = this.agendaDOM.nativeElement.querySelector('.cal-day-headers');
      this.agendaSingleHeaderWidth =  elem.offsetWidth/7;
      this.agendaOffsetLeft = this.getOffsetLeft(elem);
    }
  }

  handleDragEnd(e) {
    e.target.style.opacity = '1.0';
    this.dragClass = '';
    this.dragDay = null;
    if (this.ghost) {
      this.ghost.parentNode.removeChild(this.ghost);
      this.ghost = null;
    }
  }

  handleDragOver(e, day?) {
    // To allow a drop, we must prevent the default handling of the element. This is done by calling the
    // event.preventDefault() method for the ondragover event.
    if (e.preventDefault) {
      e.preventDefault();
    }

    // Cursor. If day is defined we're in the month view
    if (day) {
      e.dataTransfer.dropEffect = moment(day.date).isBefore(this.dragCurrentDay) ? 'none' : 'move';
    } else if (this.view === 'week') {
      const offsetX = e.clientX - this.agendaOffsetLeft;
      const offsetDays = Math.floor(offsetX / this.agendaSingleHeaderWidth);
      this.currentTargetDay = getFirstDayOfWeek(this.viewDate).add(offsetDays, 'day');
      e.dataTransfer.dropEffect = this.currentTargetDay.isBefore(moment().startOf('day')) ? 'none' : 'move';
    } else {
      e.dataTransfer.dropEffect = moment(this.viewDate).startOf('day').isBefore(this.dragCurrentDay) ? 'none' : 'move';
    }

    return false;
  }

  // funcion helper TODO: moverla a un archivo de utils
  getOffsetLeft(elem) {
    let offsetLeft = 0;
    do {
      if (!isNaN(elem.offsetLeft)) {
        offsetLeft += elem.offsetLeft;
      }
    } while (elem = elem.offsetParent);
    return offsetLeft;
  }

  handleDrop(e, day?) {
    if (e.stopPropagation) {
      e.stopPropagation(); // stops the browser from redirecting.
    }

    if (this.view === 'week') {
      day = {date: this.currentTargetDay.toDate()};
    }
    if (this.view === 'day') {
      day = {date: this.viewDate};
    }

    if (moment(day.date).startOf('day').isSame(this.dragDay) && this.view !== 'day') {
      return false;
    }

    let hourOffset;
    if (this.view === 'day') {
      // Calcular la hora de la celda donde hacemos el drop. Cuidado porque el drop puede hacerse sobre otra consigna o sobre una fila
      if (e.target.offsetParent.className === 'cal-event-container') {
        hourOffset = Math.floor((e.offsetY + e.target.offsetParent.offsetTop) / 30);
      } else {
        hourOffset = Math.floor(e.target.offsetTop / 30);
      }
    }

    const eventId = e.dataTransfer.getData('text/plain');

    this.dialogsService.confirm(null,
      this.view !== 'day' ?
      '¿Está seguro de que desea cambiar la fecha de inicio de esta consigna?' :
      '¿Está seguro de que desea cambiar el horario de inicio de esta consigna?',
      'SÍ',
      'NO'
    ).subscribe( res => {
      if (res){
        console.log(this.events.find(c => c.id === eventId));
        this.agendaService.moveConsigna(eventId, day.date, hourOffset)
          .subscribe(_ => {

            this.loadDefaultEvents();
          });
      }
    });

    return false;
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    this.selectedDate = date;
    this.selectedDateEvents = events || [];

    this.retrieveWeekEvents(date, !events);
  }

  getDetailEventsLabelDay(){

    if (moment(this.selectedDate).isSame(new Date(), 'day')){
      return 'Hoy';
    }

    return moment(this.selectedDate).format('DD/MM/YYYY');
  }

  getDetailEventsLabelWeek(){
    if (moment(this.selectedDate).isSame(new Date(), 'week')){
      return 'Esta semana';
    }

    return 'Semana del ' + getFirstDayOfWeek(this.selectedDate).format('DD/MM/YYYY');
  }

  retrieveAnyTimeEvents(){
    this.agendaService.getConsignas(null, null, false, false).subscribe(
      data => {
          if (data.ResponseData){

            this.anyTimeEvents = data.ResponseData.map(item => {

              let calendarEvent = {
                EstadoConsigna: item.EstadoConsigna,
                title: item.Title,
                id: item.Id,
                color: {
                  primary: '#4b81b0',
                  secondary: '#4b81b0'
                },
                showOwnerButtons: this.currentUserId === item.UsuarioCreadorId
              };

              return calendarEvent;
            });
          }
      });
  }

  retrieveWeekEvents(date: Date, addDateEvents?: boolean){
    let start = getFirstDayOfWeek(date).toDate();
    let end = getLastDayOfWeek(date).toDate();
    this.agendaService.getConsignas(start, end, false, true).subscribe(
      data => {
          if (data.ResponseData){

            const startTodayDate = dateToUnixTime(this.selectedDate);
            const endTodayDate = startTodayDate + 24 * 60 * 60;

            this.weekEvents = data.ResponseData.map(item => {

              let endDate = parseDate(item.EndDate);
              let startDate = parseDate(item.StartDate);

              let calendarEvent = {
                EstadoConsigna: item.EstadoConsigna,
                end: endDate,
                start: startDate,
                title: item.Title,
                id: item.Id,
                color: {
                  primary: '#4b81b0',
                  secondary: '#4b81b0'
                },
                showOwnerButtons: this.currentUserId === item.UsuarioCreadorId
              };

              if (addDateEvents) {
                if (item.StartDate <= endTodayDate &&
                    item.EndDate >= startTodayDate)
                {
                  this.selectedDateEvents.push(calendarEvent);
                }
              }

              return calendarEvent;
            });
          }
      });
  }

  handleEvent(action: string, event: CalendarEvent): void {

  }

  beforeViewRender(event){

  }

  onFinishConsigna(event){
    this.dialogsService.showRateConsignaDialog()
      .subscribe( res => {
          if (res){
            this.agendaService.rateConsigna(event.id, res)
              .subscribe( data => {
                if(this.weekEvents.filter(item => item.id == event.id).length > 0){
                  this.weekEvents.find(item => item.id == event.id).EstadoConsigna = 'Realizada';
                }else{
                  this.anyTimeEvents = this.anyTimeEvents.filter(item => item.id !== event.id);
                }
                this.loadDefaultEvents();
              });
          }
      });
  }

  onReactivateConsigna(event){
    this.dialogsService.confirm(null,
              "¿Está seguro de que desea reactivar esta consigna?",
              "SÍ, REACTIVAR",
              "NO, CANCELAR")
    .subscribe( res => {
      if (res){
        this.agendaService.reactivateConsigna(event.id)
          .subscribe( data => {
            this.loadDefaultEvents();
          });
      }});
  }

  onDeleteConsigna(event){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta consigna?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.agendaService.deleteConsigna(event.id)
            .subscribe( data => {
              if(this.weekEvents.filter(item => item.id == event.id).length > 0){
                this.weekEvents = this.weekEvents.filter(item => item.id !== event.id);
              }else{
                this.anyTimeEvents = this.anyTimeEvents.filter(item => item.id !== event.id);
              }
              this.loadDefaultEvents();
            });
        }});
  }

  public navigateToBuscador(){
    this.router.navigate([PATH_BUSCADOR, PATH_BUSCADOR_CONSIGNAS]);
  }

  onSelect(event){
    this.router.navigate([PATH_CONSIGNA_DETAIL, event.id]);
  }

  public showNewConsignaDialog(){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES')
      .subscribe( (data: any ) => {
        console.log(data);
        if (data) {
          this.newConsignaResponse = data.ResponseData;
          if(this.newConsignaResponse && this.newConsignaResponse.length > 0){
            //Borrador
            if(this.newConsignaResponse[0].StartDate == 0 && this.newConsignaResponse[0].EndDate == 0){
                let item = this.newConsignaResponse[0];
                let calendarEvent = {
                  title: item.Title,
                  id: item.Id,
                  color: {
                    primary: '#4b81b0',
                    secondary: '#4b81b0'
                  },
                  EstadoConsigna: 'Activa',
                  showOwnerButtons: true
                };
                this.anyTimeEvents.push(calendarEvent);

            }else{
              //Comun
              let start = getFirstDayOfWeek(this.selectedDate).toDate();
              let end = getLastDayOfWeek(this.selectedDate).toDate();
              let endDate = parseDate(this.newConsignaResponse[0].EndDate);
              let startDate = parseDate(this.newConsignaResponse[0].StartDate);
              const startTodayDate = dateToUnixTime(this.selectedDate);
              const endTodayDate = startTodayDate + 24 * 60 * 60;

              if( startDate >= start && endDate <= end){
                let item = this.newConsignaResponse[0];
                let calendarEvent = {
                  EstadoConsigna: item.EstadoConsigna,
                  end: endDate,
                  start: startDate,
                  title: item.Title,
                  id: item.Id,
                  color: {
                    primary: '#4b81b0',
                    secondary: '#4b81b0'
                  },
                  showOwnerButtons: true
                };

                this.weekEvents.push(calendarEvent);

                if (item.StartDate <= endTodayDate &&
                    item.EndDate >= startTodayDate)
                {
                  this.selectedDateEvents.push(calendarEvent);
                }
              }

              this.loadDefaultEvents();
            }
          }
        }
      });
  }

  onDoubleClickCell($event, day){

    //if (!day.events.length){
      this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, null, null, day.date)
      .subscribe( () => {
        this.loadDefaultEvents();
      });
    //}
  }

  dayViewConsignaClick(dayEvent: CalendarEvent) {
    let tmp = {
      date: this.viewDate as Date,
      events: [dayEvent] as CalendarEvent[]
    };
    this.dayClicked(tmp);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/agenda/agenda.component.ts